import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './index';
import type { User as UserType } from '../types/user';
import { auth } from '../services/api';
import store from './index';

type User = UserType;

interface UserState {
  user: User | null;
  loading: boolean;
  error: string | null;
  initializing: boolean;
}

// 尝试从localStorage恢复用户状态
const initializeUserState = async (): Promise<UserState> => {
  const token = localStorage.getItem('token');
  if (token) {
    try {
      const user = await auth.getCurrentUser();
      return {
        user,
        loading: false,
        error: null,
        initializing: false,
      };
    } catch (error) {
      localStorage.removeItem('token');
    }
  }
  return {
    user: null,
    loading: false,
    error: null,
    initializing: true,
  };
};

const initialState: UserState = {
  user: null,
  loading: false,
  error: null,
  initializing: true,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.loading = false;
      state.error = null;
      state.initializing = false;
    },
    clearUser: (state) => {
      state.user = null;
      state.loading = false;
      state.error = null;
      state.initializing = false;
      localStorage.removeItem('token');
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setInitializing: (state, action: PayloadAction<boolean>) => {
      state.initializing = action.payload;
    },
  },
});

// 初始化用户状态
initializeUserState().then((state) => {
  if (state.user) {
    store.dispatch(setUser(state.user));
  } else {
    store.dispatch(setInitializing(false));
  }
});

export const { setUser, clearUser, setLoading, setError, setInitializing } = userSlice.actions;

export const selectUser = (state: RootState) => state.user.user;
export const selectUserLoading = (state: RootState) => state.user.loading;
export const selectUserError = (state: RootState) => state.user.error;
export const selectUserInitializing = (state: RootState) => state.user.initializing;

export default userSlice.reducer; 